export default "__VITE_ASSET__Bu6KC0zQ__";